<p class="alert-modal__message">{{ data.message | translate: data.messageParams }}</p>

<ng-template #footerTpl>
  <p-button type="button" severity="contrast" [label]="data.confirmLabel | translate" (onClick)="dismiss()" />
</ng-template>
